var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { triggerAnalyticsEvent as replacementCardTriggerAnalyticsEvents } from 'syf-js-utilities';
import theme from './theme';
import ReplacementLostStolen from './views';
import { ConfigProvider } from './context/config.context';
const ReplacementLostStolenMFE = (_a) => {
    var { config, accountId, authenticationRedirect, triggerAnalyticsEvent = replacementCardTriggerAnalyticsEvents, navigationHandler } = _a, appProps = __rest(_a, ["config", "accountId", "authenticationRedirect", "triggerAnalyticsEvent", "navigationHandler"]);
    return (_jsx(ThemeProvider, Object.assign({ theme: theme }, { children: _jsx(ConfigProvider, Object.assign({ config: config, accountId: accountId, authenticationRedirect: authenticationRedirect, triggerAnalyticsEvent: triggerAnalyticsEvent, navigationHandler: navigationHandler }, { children: _jsx(ReplacementLostStolen, Object.assign({}, appProps)) })) })));
};
export * from './typings';
export default ReplacementLostStolenMFE;
//# sourceMappingURL=index.js.map